import { Directive, ElementRef, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { DashboardService } from '../services/dashboard.service';

@Directive({
    selector: '[slHideIfDashboardEditMode]',
    standalone: false
})
export class HideIfDashboardEditModeDirective implements OnInit, OnDestroy {
    private subscription: Subscription;

    private readonly elementRef = inject(ElementRef);
    private readonly dashboardService = inject(DashboardService);
    private readonly renderer2 = inject(Renderer2);

    ngOnInit(): void {
        this.subscription = this.dashboardService.getEditModeStatus().subscribe(isInEditMode => {
            if (isInEditMode) {
                this.renderer2.setStyle(this.elementRef.nativeElement, 'display', 'none');
            } else {
                this.renderer2.removeStyle(this.elementRef.nativeElement, 'display');
            }
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
